/* global google */
import $ from 'jquery';

// TODO: rewrite in ES6
const GoogleMaps = (function () {

    /**
     * @param $container
     * @param settings object
     * @constructor
     */
    function GoogleMaps($container, settings) {
        const googleMaps = this;

        googleMaps.$container = $container;
        googleMaps.map = null;
        googleMaps.markers = [];

        const defaults = {
            zoom: 15,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false,
            streetViewControl: false
        };

        googleMaps.settings = $.extend({}, defaults, settings);

        console.log(googleMaps.settings);

        return googleMaps;
    }

    GoogleMaps.prototype = {
        init() {
            const googleMaps = this;

            googleMaps.map = new google.maps.Map(googleMaps.$container[0], googleMaps.settings);
            return googleMaps;
        },
        setStyles(styles) {
            const googleMaps = this;
            googleMaps.map.setOptions({ styles });
            return googleMaps;
        },
        addMarker(options) {
            const googleMaps = this;

            const defaults = {
                position: new google.maps.LatLng(0, 0),
                map: googleMaps.map
            };

            const settings = $.extend({}, defaults, options);

            const marker = new google.maps.Marker(settings)
            this.markers.push(marker);

            return marker;
        },
        centerMap(latLng) {
            const googleMaps = this;
            googleMaps.map.setCenter(latLng);
            return googleMaps;
        }
    };

    return GoogleMaps;
}());

export default GoogleMaps;



// WEBPACK FOOTER //
// ./src/js/modules/GoogleMaps.js